import * as React from 'react';

const ReCAPTCHA = ({ onChange, sitekey, badge, theme, size }) => {
  const recaptchaRef = React.useRef(null);

  React.useEffect(() => {
    const handleCallback = (token) => {
      if (onChange) {
        onChange(token);
      }
    };

    const renderReCAPTCHA = () => {
      const recaptcha = window.grecaptcha?.enterprise;
      if (recaptcha && recaptchaRef.current) {
        recaptcha.render(recaptchaRef.current, {
          sitekey: sitekey,
          badge: badge,
          theme: theme,
          size: size,
          callback: handleCallback,
        });
      }
    };

    const checkRecaptchaLoaded = setInterval(() => {
      if (window.grecaptcha?.enterprise && window.grecaptcha?.enterprise?.render && recaptchaRef.current && !recaptchaRef.current.hasChildNodes()) {
        clearInterval(checkRecaptchaLoaded);
        renderReCAPTCHA();
      }
    }, 100);

    return () => clearInterval(checkRecaptchaLoaded);
  }, [badge, size, sitekey, theme, onChange]);

  return (
    <>
      <div id="recaptcha-container" ref={recaptchaRef}></div>
    </>
  );
};

export default ReCAPTCHA;
